import {useEffect} from 'react'
import {useSearchParams} from 'react-router-dom'
import {fetchConToken} from '../helpers/fetch'
import {useAuth2} from '../modules/authv2/Auth2Provider'
import {SuspensedView} from './SuspensedView'

const decodeJWT = (token: string) => {
  try {
    const base64Url = token.split('.')[1] // Extraer el payload
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/') // Convertir a Base64 estándar
    const decodedData = JSON.parse(atob(base64)) // Decodificar Base64 y convertir a objeto
    return decodedData
  } catch (error) {
    console.error('Error al decodificar el JWT', error)
    return null
  }
}

const AuthCallback = () => {
  const {setUserData, urlLogout, setUrlLogout} = useAuth2()
  const [searchParams, _] = useSearchParams()

  const token = searchParams.get('token')
  const authenticateUser = async () => {
    if (token) {
      try {
        revalidateUser(token)
      } catch (error) {
        console.log(error)
        localStorage.clear()
        window.location.replace(urlLogout)
      }
    } else {
      const urlLogoutLS = localStorage.getItem('urlLogout') || urlLogout || ''
      window.location.replace(urlLogoutLS)
      localStorage.clear()

      localStorage.setItem('urlLogout', urlLogoutLS)
    }
  }

  const fetchProfile = async (token: string) => {
    const url = 'auth/profile'
    const resp = await fetchConToken(url, {}, 'GET', token)
    const body = await resp.json()

    return body
  }

  const revalidateUser = async (token: string) => {
    const decodedToken = decodeJWT(token)
    localStorage.setItem('urlApi', decodedToken.urlApi)
    localStorage.setItem('urlLogout', decodedToken.urlLogout)
    localStorage.setItem('authToken', token)
    setUrlLogout(decodedToken.urlLogout)

    searchParams.delete('token')

    const newUrl = '/dashboard'
    window.history.replaceState({}, '', newUrl)

    const profile = await fetchProfile(token)

    if (profile?.userId) {
      localStorage.setItem('userData', JSON.stringify(profile))
      setUserData(profile)
      window.location.reload()
    } else {
      window.location.replace(urlLogout)
      localStorage.clear()
    }
  }

  useEffect(() => {
    authenticateUser()
  }, [])

  return <SuspensedView>Loading....</SuspensedView>
}

export {AuthCallback}
